import {PageLink} from '../../../../_metronic/layout/core'
import {useIntl} from 'react-intl'

export const RecordsKeeperAIBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const RecordsKeeperAIOverviewBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Overview',
    path: 'rk/overview',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
export const RecordsKeeperAIRecordsFilesBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Records & Files',
    path: 'rk/records-and-files',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
export const RecordsKeeperAISourcesAndSyncBreadCrumbs: Array<PageLink> = [
  {
    title: 'Home',
    path: '/',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
  {
    title: 'Sources & Sync',
    path: 'rk/sources-and-sync',
    isSeparator: false,
    isActive: true,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

export const RecordsKeeperAIBreadcrumbs = () => {
  const {formatMessage} = useIntl()

  const RecordsKeeperAIBreadCrumbs: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const RecordsKeeperAIOverviewBreadCrumbs: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Overview'}),
      path: 'rk/overview',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  const RecordsKeeperAIRecordsFilesBreadCrumbs: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Records & Files'}),
      path: 'rk/records-and-files',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]
  const RecordsKeeperAISourcesAndSyncBreadCrumbs: Array<PageLink> = [
    {
      title: formatMessage({id: 'Home'}),
      path: '/',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
    {
      title: formatMessage({id: 'Sources & Sync'}),
      path: 'rk/sources-and-sync',
      isSeparator: false,
      isActive: true,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return {
    RecordsKeeperAIBreadCrumbs,
    RecordsKeeperAIOverviewBreadCrumbs,
    RecordsKeeperAIRecordsFilesBreadCrumbs,
    RecordsKeeperAISourcesAndSyncBreadCrumbs,
  }
}

export enum RecordSync {
  GOOGLE_DRIVE = 'GDrive',
  DROPBOX = 'DropBox',
  ONEDRIVE = 'OneDrive',
  AWS_S3 = 'S3',
  AZURE_BLOB = 'Azure',
  GOOGLE_BUCKET = 'GCloud',
  LOCAL = 'Local',
  ZIP_FILE = 'ZipFile',
}

export const OauthIntegrationTypes = [
  RecordSync.GOOGLE_DRIVE,
  RecordSync.DROPBOX,
  RecordSync.ONEDRIVE,
]

export const CloudStorageIntegrationTypes = [
  RecordSync.AWS_S3,
  RecordSync.AZURE_BLOB,
  RecordSync.GOOGLE_BUCKET,
]

export const storageIcons = {
  [RecordSync.GOOGLE_DRIVE]: 'ic-gdrive',
  [RecordSync.DROPBOX]: 'ic-onedrive',
  [RecordSync.ONEDRIVE]: 'ic-mscloud',
  [RecordSync.AWS_S3]: 'ic-amazon-s3',
  [RecordSync.AZURE_BLOB]: 'ic-azure',
  [RecordSync.GOOGLE_BUCKET]: 'ic-gcloud',
  [RecordSync.LOCAL]: 'ic-localupload',
  [RecordSync.ZIP_FILE]: 'ic-ext-zip',
}

export const cloudRegionTypes = [
  {id: 1, label: 'us-east-1', value: 'us-east-1'},
  {id: 2, label: 'us-east-2', value: 'us-east-2'},
  {id: 3, label: 'us-west-1', value: 'us-west-1'},
  {id: 4, label: 'us-west-2', value: 'us-west-2'},
  {id: 5, label: 'ap-east-1', value: 'ap-east-1'},
  {id: 6, label: 'ap-south-1', value: 'ap-south-1'},
  {id: 7, label: 'ap-south-2', value: 'ap-south-2'},
  {id: 8, label: 'ap-northeast-1', value: 'ap-northeast-1'},
  {id: 9, label: 'ap-northeast-2', value: 'ap-northeast-2'},
  {id: 10, label: 'ap-northeast-3', value: 'ap-northeast-3'},
  {id: 11, label: 'ap-southeast-1', value: 'ap-southeast-1'},
  {id: 12, label: 'ap-southeast-2', value: 'ap-southeast-2'},
  {id: 13, label: 'ap-southeast-3', value: 'ap-southeast-3'},
  {id: 14, label: 'ap-southeast-4', value: 'ap-southeast-4'},
  {id: 15, label: 'ca-central-1', value: 'ca-central-1'},
  {id: 16, label: 'cn-north-1', value: 'cn-north-1'},
  {id: 17, label: 'cn-northwest-1', value: 'cn-northwest-1'},
  {id: 18, label: 'eu-central-1', value: 'eu-central-1'},
  {id: 19, label: 'eu-west-1', value: 'eu-west-1'},
  {id: 20, label: 'eu-west-2', value: 'eu-west-2'},
  {id: 21, label: 'eu-west-3', value: 'eu-west-3'},
  {id: 22, label: 'eu-north-1', value: 'eu-north-1'},
  {id: 23, label: 'eu-south-1', value: 'eu-south-1'},
  {id: 24, label: 'eu-south-2', value: 'eu-south-2'},
  {id: 25, label: 'me-south-1', value: 'me-south-1'},
  {id: 26, label: 'me-central-1', value: 'me-central-1'},
  {id: 27, label: 'af-south-1', value: 'af-south-1'},
  {id: 28, label: 'il-central-1', value: 'il-central-1'},
]

export const complianceRequirementTypes = [
  {
    id: 1,
    label:
      'GDPR: Requires explicit consent for data collection, right to access, and data portability.',
    value:
      'GDPR: Requires explicit consent for data collection, right to access, and data portability.',
  },
  {
    id: 2,
    label:
      'HIPAA: Protects sensitive patient health information from disclosure without patient consent.',
    value:
      'HIPAA: Protects sensitive patient health information from disclosure without patient consent.',
  },
  {
    id: 3,
    label:
      'CCPA: Grants California residents rights regarding their personal data, including the right to opt-out of data selling.',
    value:
      'CCPA: Grants California residents rights regarding their personal data, including the right to opt-out of data selling.',
  },
  {
    id: 4,
    label:
      'SOX: Establishes requirements for financial reporting and internal controls to protect shareholders.',
    value:
      'SOX: Establishes requirements for financial reporting and internal controls to protect shareholders.',
  },
  {
    id: 5,
    label:
      'PCI DSS: Sets security standards for organizations that handle credit card information to protect against fraud.',
    value:
      'PCI DSS: Sets security standards for organizations that handle credit card information to protect against fraud.',
  },
  {
    id: 6,
    label: 'FISMA: Requires federal agencies to secure their information systems and data.',
    value: 'FISMA: Requires federal agencies to secure their information systems and data.',
  },
  {
    id: 7,
    label:
      'ISO 27001: Specifies requirements for establishing, implementing, maintaining, and continuously improving an information security management system.',
    value:
      'ISO 27001: Specifies requirements for establishing, implementing, maintaining, and continuously improving an information security management system.',
  },
  {
    id: 8,
    label:
      'FCRA: Regulates the collection, dissemination, and use of consumer credit information to ensure fairness and accuracy.',
    value:
      'FCRA: Regulates the collection, dissemination, and use of consumer credit information to ensure fairness and accuracy.',
  },
  {
    id: 9,
    label:
      'NIST Cybersecurity Framework: Provides guidelines for improving cybersecurity practices and managing cybersecurity risks.',
    value:
      'NIST Cybersecurity Framework: Provides guidelines for improving cybersecurity practices and managing cybersecurity risks.',
  },
  {
    id: 10,
    label:
      'Data Protection Act 2018: Enhances data protection rights and obligations within the UK context, in alignment with GDPR.',
    value:
      'Data Protection Act 2018: Enhances data protection rights and obligations within the UK context, in alignment with GDPR.',
  },
  {
    id: 11,
    label:
      'Basel III: Establishes international banking regulations to promote stability and transparency in the banking sector.',
    value:
      'Basel III: Establishes international banking regulations to promote stability and transparency in the banking sector.',
  },
  {
    id: 12,
    label:
      'Anti-Money Laundering (AML): Requires financial institutions to monitor customer transactions and report suspicious activities to prevent money laundering.',
    value:
      'Anti-Money Laundering (AML): Requires financial institutions to monitor customer transactions and report suspicious activities to prevent money laundering.',
  },
  {
    id: 13,
    label:
      'COPPA: Protects the privacy of children under 13 by requiring parental consent for data collection.',
    value:
      'COPPA: Protects the privacy of children under 13 by requiring parental consent for data collection.',
  },
  {
    id: 14,
    label:
      'RTBF (Right to be Forgotten): Allows individuals to request the deletion of personal data under certain conditions, particularly in the EU.',
    value:
      'RTBF (Right to be Forgotten): Allows individuals to request the deletion of personal data under certain conditions, particularly in the EU.',
  },
  {
    id: 15,
    label:
      'SEC Regulations: Enforces securities laws to protect investors and maintain fair, orderly, and efficient markets.',
    value:
      'SEC Regulations: Enforces securities laws to protect investors and maintain fair, orderly, and efficient markets.',
  },
]

export const confidentialityLevelOptions = [
  {
    id: 'public',
    label: 'Public',
    value: 'public',
  },
  {
    id: 'internal use',
    label: 'Internal Use',
    value: 'internal use',
  },
  {
    id: 'confidential',
    label: 'Confidential',
    value: 'confidential',
  },
]

export const recordsKeeperColors = [
  '#4776E6',
  '#96B3FA',
  '#698CDE',
  '#615DD1',
  '#1B55E0',
  '#204EBD',
  '#30519F',
  '#1D3E8C',
  '#112658',
  '#041A4E',
]

export const archivalSettingsOptions = [
  {id: 1, name: 'Days from the Date of Archive Creation', value: 'Days'},
  {id: 2, name: 'Months from the Date of Archive Creation', value: 'Months'},
  {id: 3, name: 'Years from the Date of Archive Creation', value: 'Years'},
]

export const docFrequencyOptions = [
  {id: 1, label: 'One Time', value: 'one-time'},
  {id: 2, label: 'Continuous', value: 'continuous'},
  {id: 3, label: 'Hourly', value: 'hourly'},
  {id: 4, label: 'Daily', value: 'daily'},
  {id: 5, label: 'Weekly', value: 'weekly'},
  {id: 6, label: 'Biweekly', value: 'biweekly'},
  {id: 7, label: 'Semi Monthly', value: 'semi-monthly'},
  {id: 8, label: 'Monthly', value: 'monthly'},
  {id: 9, label: 'Bi Monthly', value: 'bi-monthly'},
  {id: 10, label: 'Quarterly', value: 'quarterly'},
  {id: 11, label: 'Triannual', value: 'triannual'},
  {id: 12, label: 'Semi Annual', value: 'semi-annual'},
  {id: 13, label: 'Annual', value: 'annual'},
  {id: 14, label: 'Biennial', value: 'biennial'},
  {id: 15, label: 'Triennial', value: 'triennial'},
  {id: 16, label: 'Quadrennial', value: 'quadrennial'},
  {id: 17, label: 'Decennial', value: 'decennial'},
  {id: 18, label: 'Irregular', value: 'irregular'},
]

export const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]
